import type { TFunction } from 'i18next';

import type { ChartConfig } from 'src/components/ui/chart';

export function buildChartConfig(t: TFunction<'forecast'>): ChartConfig {
  return {
    forecastProposal: {
      label: t('Forecast proposal'),
      theme: {
        light: 'var(--chart-forecast-proposal)',
        dark: 'var(--chart-forecast-proposal)',
      },
    },
    realSales: {
      label: t('Real sales'),
      theme: {
        light: 'var(--chart-real-sales)',
        dark: 'var(--chart-real-sales)',
      },
    },
    realSalesAverage: {
      label: t('Real sales average'),
      theme: {
        light: 'var(--chart-real-sales-average)',
        dark: 'var(--chart-real-sales-average)',
      },
    },
    modelProposal: {
      label: t('Model proposal'),
      theme: {
        light: 'var(--chart-model-proposal)',
        dark: 'var(--chart-model-proposal)',
      },
    },
    modelProposal2: {
      label: t('Model proposal 2'),
      theme: {
        light: 'var(--chart-model-proposal-2)',
        dark: 'var(--chart-model-proposal-2)',
      },
    },
    validatedForecast: {
      label: t('Validated forecast'),
      theme: {
        light: 'var(--chart-validated-forecast)',
        dark: 'var(--chart-validated-forecast)',
      },
    },
    b2bSales: {
      label: t('B2B sales'),
      theme: {
        light: 'var(--chart-b2b-sales)',
        dark: 'var(--chart-b2b-sales)',
      },
    },
    productPriceIndex: {
      label: t('Price index'),
      theme: {
        light: 'var(--chart-product-price)',
        dark: 'var(--chart-product-price)',
      },
    },
    stock: {
      label: t('Stock disponibility'),
      theme: {
        light: 'var(--chart-stock)',
        dark: 'var(--chart-stock)',
      },
    },
  };
}
